import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtxChatComponent } from './components/atx-chat.component';
import { AtxChatService } from './services/atx-chat.service';
import { AtxChatRemoteService } from './services/atx-chat-remote.service';
import { AtxChatListComponent } from './components/atx-chat-list.component';
import { AtxChatDetailComponent } from './components/atx-chat-detail.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        AtxChatComponent,
        AtxChatListComponent,
        AtxChatDetailComponent,
    ],
    providers: [
        AtxChatService,
        AtxChatRemoteService,
    ],
    exports: [
        AtxChatComponent,
    ],
})

export class AtxChatModule {}
